<style lang="less" scoped>
  .frame {
    overflow: hidden;
    background-size: cover;
    background-position: center center;
    &.empty {
      background: white;
    }
  }
</style>

<template lang="pug">
  .frame(
    v-if='image'
    :style='{ "background-image": `url(/static/images/${image}.png)` }')
  .frame.empty(v-else)
</template>

<script>
export default {
  props: {
    image: {},
  },
};
</script>



// WEBPACK FOOTER //
// src/components/image_panel.vue